import type { TFunction } from 'i18next';
import { ApiError } from '@/lib/api';

/**
 * แปลง error จาก API เป็นข้อความสำหรับผู้ใช้
 * ถ้ามีคำแปลของ error code ในไฟล์ภาษาให้ใช้ก่อน ไม่งั้นใช้ข้อความภาษาไทยที่ server ส่งมา
 */
export function translateApiError(error: unknown, t: TFunction): string {
  if (error instanceof ApiError) {
    if (error.code === 'NETWORK_ERROR') return t('errors.network');
    const key = `errors.${error.code}`;
    const translated = t(key);
    return translated === key ? error.message : translated;
  }
  return t('errors.unknown');
}

export function isApiErrorCode(error: unknown, code: string): boolean {
  return error instanceof ApiError && error.code === code;
}
